import * as React from 'react';
import { Box, Grid2 } from "@mui/material";
import { ReactComponent as CrewRosteringIcon } from "assets/icons/date-range.svg";
import { ReactComponent as RailAppIcon } from "assets/icons/rail-app.svg";
import { ReactComponent as TrainAppIcon } from "assets/icons/train-app.svg";
import { ReactComponent as DIAppIcon } from "assets/icons/di-app.svg";
import { AppsH1 } from "components/menu/Labels";
import { openInANewBrowser } from 'helpers/HelperFunctions';
import appSettings from 'shared/settings/appSettings';

export interface IApplicationItem {
    name: string,
    icon?: any,
    image?: any,
    className: string,
    url: string
}

const CrewRostering = {
    name: "Crew Rostering",
    icon: CrewRosteringIcon,
    className: "app-crew-rostering",
    url: "https://crewrostering.bhp.com/login"
} as IApplicationItem;

const RailApp = {
    name: "Rail App",
    icon: RailAppIcon,
    className: "app-bhp",
    url: appSettings.installAppLink
} as IApplicationItem;

const EHBCApp = {
    name: "EHBC",
    icon: TrainAppIcon,
    className: "app-bhp",
    url: "https://ehbc.bhp.com"
} as IApplicationItem;

const DIApp = {
    name: "Driver Insights",
    icon: DIAppIcon,
    className: "app-bhp",
    url: "https://driver-insights.p33.minerals.cloud/"
} as IApplicationItem;

export const ApplicationData = [CrewRostering, RailApp, EHBCApp, DIApp] as IApplicationItem[];

const AppCard = (props: { item: IApplicationItem }) => {
    const Icon = props.item.icon;

    return (
        <Box className={"app-card clickable box-shadow " + props.item.className} onClick={() => { openInANewBrowser(props.item.url) }}>
            <Box className="icon-container center-children-both">
                {props.item.icon && !props.item.image &&
                    <Icon className="icon" />
                }
                {props.item.image &&
                    <img src={props.item.image} alt="App Logo" />
                }
            </Box>

            <Box className="name">{props.item.name}</Box>
        </Box>
    );
};

export const ApplicationsCard = () => {
    return (<div className="info-card">
        <AppsH1 />

        <div className="mt-5"></div>

        <Grid2 container>
            {ApplicationData.map((app, idx) =>
                <>
                    {app.url &&
                        <div key={idx} className="info-card-app">
                            <AppCard item={app} />
                        </div>
                    }
                </>
            )}
        </Grid2>
    </div>);
};

export default ApplicationsCard;